import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { agent } from "./agent";
import * as API from "./apiPath";
import PropTypes from "prop-types";

const SSORouteProtection = ({ children }) => {

  const [isSSOEnabled, setIsSSOEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchSSOModeFromAPI = async () => {
      try {
        const response = await agent.get(API.SETTING);
        const ssoEnabled = response?.data?.data?.is_sso_enable === "1";
        setIsSSOEnabled(ssoEnabled);
      } catch (error) {
        console.error("Error fetching SSO settings:", error);
        setIsSSOEnabled(false);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSSOModeFromAPI();
  }, []);

  // If still loading, don't redirect yet
  if (isLoading) {
    return children;
  }

  // If SSO is enabled and user doesn't have a role, redirect to home
  if (isSSOEnabled ) {
    return <Navigate to="/" replace />;
  }

  return children;
};

SSORouteProtection.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SSORouteProtection;
